import { render } from "./AIoTAcceleratorView.vue?vue&type=template&id=3fa02ed6&ts=true"
import script from "./AIoTAcceleratorView.vue?vue&type=script&lang=ts"
export * from "./AIoTAcceleratorView.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__